import { tick } from '@angular/core/testing';

export class HisContentMatcherConfiguration {
    public toIgnoreKeys?: string[];
    public dateKeys?: string[];
}

export function tickAndDetectChanges(fixture: any) {
    tick();
    fixture.detectChanges();

    tick();
    fixture.detectChanges();
}

function isObject(jsonDataKey: any): boolean {
    return typeof jsonDataKey === 'object' && jsonDataKey !== null;
}

function getMergedKeys(nameOfObject: string, theKey: string): string {
    return (nameOfObject ? nameOfObject + '.' + theKey : theKey);
}

function normalizeValue(value: any) {
    if (typeof value === 'string') {
        value = value.trim().replace(/\r/g, '');
    }
    if (value === null || value === '') {
        value = undefined;
    }
    return value;
}

export function matchContent(oldVersionJson: any, newVersionJson: any, objectName: string, config?: HisContentMatcherConfiguration): string[] {

    let arrayOfErrors: string[] = [];
    const keysToIgnore: string[] = (config?.toIgnoreKeys || []).concat(['lockVersion', 'objGuid', 'cvLockVersion']);

    for (let key in oldVersionJson) {
        let keysPath = getMergedKeys(objectName, key);

        if (keysToIgnore.includes(key) || keysToIgnore.includes(keysPath)) {
            continue;
        }
        if (!(key in newVersionJson)) {
            arrayOfErrors.push('\nThe Key ' + keysPath + ' exists in the old version, but not in the new version!\n The old Version: "' + oldVersionJson[key] + '", \n The new Version: "' + newVersionJson[key] + '"\n');
            continue;
        }
        let oldValue = normalizeValue(oldVersionJson[key]);
        let newValue = normalizeValue(newVersionJson[key]);
        if (isObject(oldValue)) {
            arrayOfErrors = arrayOfErrors.concat(matchContent(oldValue, newValue, keysPath, config));
        } else {
            let dateKey = config?.dateKeys?.includes(key) || config?.dateKeys?.includes(keysPath);
            if (!compareValues(oldValue, newValue, dateKey)) {

                arrayOfErrors.push('\nThe contents of the key ' + keysPath + ' differ between the old and the new version!\n The old Version: "' + oldValue + '", \n The new Version: "' + newValue + '"\n');
            }
        }
    }
    return arrayOfErrors;
}

/**
 * compares to values with tollerance
 */
function compareValues(oldValue: any, newValue: any, dateKey: boolean) {
    if (oldValue === newValue) {
        return true;
    }
    if (!dateKey || typeof(oldValue) !== 'number' || typeof(newValue) !== 'number') {
        return false;
    }
    return compareDateIgnoringYear(oldValue, newValue);
}

function compareDateIgnoringYear(oldValue: number, newValue: number) {
    if (oldValue >= 1900 && newValue >= 1900 && oldValue <= 2100 && newValue <= 2100) {
        return true;
    }

    let oldDate = new Date(oldValue);
    let newDate = new Date(newValue);
    return (oldDate.getMonth() === newDate.getMonth())
        && (oldDate.getDate() === newDate.getDate())
        && (oldDate.getHours() === newDate.getHours())
        && (oldDate.getMinutes() === newDate.getMinutes())
        && (oldDate.getSeconds() === newDate.getSeconds());
}